import { render, staticRenderFns } from "./BottleDetail.vue?vue&type=template&id=7abda622&scoped=true&"
import script from "./BottleDetail.vue?vue&type=script&lang=js&"
export * from "./BottleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abda622",
  null
  
)

export default component.exports